import moment from "moment";
import TimeEntry from "../../../timesheet/services/timesheets/timeentry.model";
import {
  approvalTemplate,
  approvalController,
  remindTemplate,
  remindController,
  rejectController,
  rejectTemplate
} from "../index"


class TimesheetDetailController {
  constructor(AuthenticationService, $http, $rootScope, $state, $uibModal) {
    "ngInject";
    var self = this;

    const { timesheetId } = $state.params;

    self.authenticationService = AuthenticationService;
    self.name = "timesheetDetail";
    self.$http = $http;
    self.$rootScope = $rootScope;
    self.timesheetId = timesheetId;
    self.moment = moment;
    self.$uibModal = $uibModal;

    // TODO: Need a method to get a timesheet by id
    self.$http.get(`${self.$rootScope.apiHost}/api/review/timesheets/${timesheetId}`, {withCredentials: true})
      .then((response) => {
        // let timesheet = response.data.filter(timesheet => timesheet.id == self.timesheetId);
        self.timesheet = response.data;

        // Add in timesheet dates to object
        // TODO: This seems to come from the backend on this endpoint https://dev.timeclerk.com/api/timesheets/2020-06-16
        self.timesheet.timesheetDates = self.getTimesheetDates(self.timesheet.startDate, self.timesheet.endDate);
      })
  }

  getTimesheetDates(startDate, endDate) {
    let dates = [];
    let currentDate = moment(startDate);
    let momentEndDate = moment(endDate);

    while(currentDate <= momentEndDate){
      dates.push(moment(currentDate).format("YYYY-MM-DD"));
      currentDate = moment(currentDate).add(1, 'days');
    }

    return dates;
  }

  hasTimeEntries() {
    if(this.timesheet) {
      return this.timesheet.timeEntries.length > 0;
    } else {
      return false;
    }
  }


  canApprove(timesheet) {
    return this.timesheet.status !== 'SUBMITTED' && this.timesheet.status !== 'APPROVED';
  }

  canReject(timesheet) {
    return this.timesheet.status === 'REJECTED' || this.timesheet.status === 'OPEN';
  }

  canRemind(timesheet) {
    return this.timesheet.status === 'SUBMITTED' || this.timesheet.status === 'REJECTION_REQUESTED' || this.timesheet.status === 'APPROVED';
  }

  getChargeCodes() {
    let chargeCodes = [];
    if(this.timesheet) {
      this.timesheet.timeEntries.forEach(function (timeEntry) {
        _.remove(chargeCodes, function (cc) {
          return cc.name === timeEntry.chargeCode.name;
        });

        chargeCodes.push(timeEntry.chargeCode);
      });
    }

    return chargeCodes
  }

  timeEntryForChargeCodeAndDate(chargeCode, date) {
    if(this.timesheet) {
      let timeEntry = _.find(this.timesheet.timeEntries, function (te) {
        let sameDate = moment(date).isSame(moment(te.date));
        let sameChargeCode = te.chargeCode.name === chargeCode.name;
        return sameDate && sameChargeCode;
      });

      if (!timeEntry) {
        timeEntry = new TimeEntry({'date': moment(date), 'chargeCode': chargeCode});
        this.timesheet.timeEntries.push(timeEntry);
      }

      return [timeEntry];
    }
  }

  isWeekend(date) {
    return (moment(date).weekday() === 0 || moment(date).weekday() == 6);
  }

  getTotalChargeCodeTime(chargeCode) {
    let x = _.filter(this.timesheet.timeEntries, function (o) {
      return o.chargeCode.name === chargeCode.name
    });

    return this.sum(x);
  }

  getDailyTotal(date) {
    let x = _.filter(this.timesheet.timeEntries, function (o) { return moment(o.date).isSame(moment(date,'YYYY-MM-DD'))});
    return this.sum(x);
  }

  getTotalTime() {
    if(this.timesheet) {
      return this.sum(this.timesheet.timeEntries);
    }
  }

  sum(entries) {
    return _.sumBy(entries, function (o) { return Number(o.hours) ? o.hours : 0; });
  }

  approveTimesheet(){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: approvalTemplate,
      controller: approvalController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return [self.timesheet];
        }
      },
      windowClass: "hmodal-success"
    })

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
      });
    }
  }

  rejectTimesheet(){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: rejectTemplate,
      controller: rejectController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return [self.timesheet];
        }
      },
      windowClass: "hmodal-danger"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
      });
    }
  }

  remindTimesheet(){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: remindTemplate,
      controller: remindController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return [self.timesheet];
        }
      },
      windowClass: "hmodal-warning"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
      });
    }

  }
}

export default TimesheetDetailController;



// WEBPACK FOOTER //
// ./client/pages/review/modals/timesheet-detail/timesheet-detail.controller.js